import { useState, lazy, Suspense } from "react";
import { Polvo } from "./Polvo";
import { Giro } from "./Modal";
import { useT } from "../lib/i18n";

// El widget de LI.FI pesa (trae su propia gestión de wallet y cientos de tokens), así que se carga
// aparte y solo cuando se abre la pestaña — no lastra el arranque de la app.
const PuenteJumper = lazy(() => import("./PuenteJumper").then((m) => ({ default: m.PuenteJumper })));

/**
 * Puente: traer dinero de otra cadena (o cambiar de token en la misma) para poder invertir aquí. Es
 * el paso ANTERIOR a abrir una piscina y sin él mucha gente no llega — tiene USDC en Base y el vault
 * que quiere está en Robinhood.
 *
 * Dos pestañas con el mismo propósito, distinto gesto: TRAER/​cambiar con el widget de Jumper/LI.FI
 * (agrega todos los puentes y elige la ruta más barata), y BARRER a un estable todo lo que ha
 * quedado suelto por ahí (ver `Polvo`).
 */
export function Puente({ alVolver }: { alVolver: () => void }) {
  const t = useT();
  const [modo, setModo] = useState<"traer" | "polvo">("traer");

  return (
    <section className="bridge">
      <header className="cabecera">
        <button className="btn fantasma" onClick={alVolver}>{t("← Volver")}</button>
        <div className="mod-titulo">
          <span className="mod-ico" aria-hidden>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
              <path d="M3 16V8" /><path d="M21 16V8" /><path d="M3 12c4-4 14-4 18 0" /><path d="M3 16h18" /><path d="M8 16v-2M16 16v-2" />
            </svg>
          </span>
          <div>
            <h1>{t("Bridge y Swap")}</h1>
            <p className="sub" style={{ margin: 0 }}>
              {modo === "polvo"
                ? t("Junta lo que te ha quedado suelto en cualquier red y conviértelo a un estable. Keellabs cobra 0,05% del importe; lo que cobre el puente o el DEX ya viene descontado en lo que recibes. El gas de la red va aparte.")
                : t("Cambia y mueve dinero entre cadenas con la ruta más barata (Jumper/LI.FI). Comisión total 0,30% del importe: 0,25% de LI.FI + 0,05% de Keellabs. El gas de la red va aparte.")}
            </p>
          </div>
        </div>
      </header>

      <div className="conmutador">
        <button className={`chip ${modo === "traer" ? "activo" : ""}`} onClick={() => setModo("traer")}>
          {t("Traer dinero")}
        </button>
        <button className={`chip ${modo === "polvo" ? "activo" : ""}`} onClick={() => setModo("polvo")}>
          {t("Barrer restos")}
        </button>
      </div>

      {modo === "polvo" && <Polvo />}

      {modo === "traer" && (
        <Suspense fallback={<div className="panel" style={{ display: "grid", placeItems: "center", minHeight: 320 }}>
          <Giro texto={t("Cargando el puente…")} />
        </div>}>
          <div className="panel-jumper">
            <PuenteJumper />
          </div>
        </Suspense>
      )}
    </section>
  );
}
